import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const VatExceptionCategorySelect = ({ title, defaultValue = null, handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectVatExemptionCategory") : title;
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleChange = (e) => {
    setSelectedCategory(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getCategories = async () => {
    try {
      const response = await apiService.get(`api/v1/vat-exemption-categories`);
      const availableCategories = response.map((el) => {
        return {
          value: el.id,
          label: el.description,
        };
      });
      setCategories(availableCategories);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedCategory = categories.find((el) => el.value === defaultValue);
    if (selectedCategory) setSelectedCategory(selectedCategory);
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    setNewValue();
  }, [defaultValue, categories]);

  return (
    <>
      <Form.Group>
        {selectedCategory ? (
          <label>{title}</label>
        ) : (
          <label className="text-danger">
            <i className="fa fa-exclamation-circle"></i> {title}
          </label>
        )}
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="vatExceptionCategorySelect"
          onChange={handleChange}
          value={selectedCategory}
          options={categories}
          noOptionsMessage={() => t("messages.noCategoriesAreAvailable")}
          placeholder={`${title}`}
        />
      </Form.Group>
    </>
  );
};

export default VatExceptionCategorySelect;
